export default __webpack_public_path__ + "870c8c1486f76054301a22c35403eae1.woff2";